
















































































import { Simulation } from "@/api/coverageAnalysis";
import { capitalize } from "@/utils/utils";
import { defineComponent, PropType } from "vue";
import { mapMutations, mapState } from "vuex";
import CoverageAnalysesResult, { CoverageAnalysesResultEnum } from "../CoverageAnalysesResult/index.vue";

type CoverageAnalysesExam = {
  Descricao: string;
  state: CoverageAnalysesResultEnum;
  Data: string;
  CodigoExame: string;
  IdSimulacao: number;
};

export type CoverageAnalysesItemModel = {
  Periodo: string;
  Quantidade: number;
  Exames: CoverageAnalysesExam[];
};

export default defineComponent({
  components: {
    CoverageAnalysesResult
  },
  props: {
    data: {
      type: Object as PropType<Simulation>,
      required: true
    }
  },
  data() {
    return {
      showRequerDutModal: false
    };
  },
  methods: {
    ...mapMutations("coverageAnalysis", ["SET_SELECTED_EXAMS"]),
    goRequest() {
      if (this.pendencyType === "both" || this.pendencyType === "request") {
        this.$router.push({ name: "create.request", query: { tipo: "pedido" } });
      } else if (this.pendencyType === "authorization") {
        this.$router.push({
          path: "/auths/create",
          query: { origin: "analise-cobertura" }
        });
      }
    },
    capitalize(text) {
      return capitalize(text);
    },
    onAccordionHeaderClick(isExpanded: boolean) {
      if (isExpanded && this.hasRequerDutInItem) {
        this.showRequerDutModal = true;
      }
    },
    getResult(exam) {
      if (exam?.CodigoExame === "") {
        return "request";
      }

      if (exam?.ExigeAutorizacao) {
        return "authorization";
      }

      return "coverage";
    },
    async showLaboratories() {
      await this.SET_SELECTED_EXAMS([]);
      this.$router.push({
        name: "analise_cobertura.ver_laboratorios",
        query: { id: this.data?.IdSimulacao }
      });
    },
    onModalContinuar() {
      this.showRequerDutModal = false;
    }
  },
  computed: {
    ...mapState("coverageAnalysis", ["authorized"]),
    hasRequerDutInItem(): boolean {
      const data = this.data as any;
      if (data?.RequerDut === true) return true;
      return (this.data as Simulation).Exames?.some((e: any) => e.RequerDut === true) ?? false;
    },
    hasRequiresAuthorization() {
      return (this.data as Simulation).Exames.some(e => e.ExigeAutorizacao === true);
    },
    hasExamNotFound() {
      return (this.data as Simulation).Exames.some(e => e.CodigoExame === "");
    },
    hasPendency(): boolean {
      return this.hasRequiresAuthorization || this.hasExamNotFound;
    },
    pendencyType(): CoverageAnalysesResultEnum | "both" {
      let pendencyType: CoverageAnalysesResultEnum | "both";

      if (this.hasRequiresAuthorization && this.hasExamNotFound) {
        pendencyType = "both";
      } else if (this.hasExamNotFound) {
        pendencyType = "request";
      } else if (this.hasRequiresAuthorization) {
        pendencyType = "authorization";
      } else {
        pendencyType = "coverage";
      }

      return pendencyType;
    },
    pendencyText() {
      const hasPendency: boolean = this.hasPendency;
      const pendencyType: CoverageAnalysesResultEnum | "both" = this.pendencyType;
      if (hasPendency) {
        switch (pendencyType) {
          case "both":
            return "Enviar documentos";
          case "authorization":
            return "Solicitar Autorização";
          case "request":
            return "Enviar pedido";
          default:
            return "";
        }
      } else {
        switch (pendencyType) {
          case "both":
            return "Documentos enviados";
          case "authorization":
            return "Autorização enviada";
          case "request":
            return "Pedido enviado";
          default:
            return "";
        }
      }
    }
  }
});
